export default {
  'pages.applicationCatalog.openDirectory': 'Application management',
  'pages.applicationCatalog.title': 'Business applications',
  'pages.applicationCatalog.selectAppHint':
    'Select an app on the left to view its details',
  'pages.applicationCatalog.backToCenter': 'Back to Applications',
  'pages.applicationCatalog.create': 'Create app',
  'pages.applicationCatalog.edit': 'Edit app',
  'pages.applicationCatalog.refresh': 'Refresh',
  'pages.applicationCatalog.details': 'Details',
  'pages.applicationCatalog.resources': 'Manage resources',
  'pages.applicationCatalog.delete': 'Delete app',
  'pages.applicationCatalog.more': 'More',
  'pages.applicationCatalog.moreForApp': 'More actions for {name}',
  'pages.applicationCatalog.deleteTitle':
    'Delete “{name}” from the entire platform?',
  'pages.applicationCatalog.deleteDescription':
    'This deletes the shared IAM app and its local extension data, affecting every company that uses the app. This action cannot be undone and does not simply disable the app for the current company.',
  'pages.applicationCatalog.deleteConfirm': 'Delete from entire platform',
  'pages.applicationCatalog.cancel': 'Cancel',
};
